import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'app/dialogs/dialog.service';
import { FollowUpTaskToAssociate } from 'app/models/follow-up-actions/follow-up-actions.model';
import { WorkflowService } from 'app/services/workflow.service';

@Component({
  selector: 'app-select-follow-up-actions',
  templateUrl: './select-follow-up-actions.component.html',
  styleUrls: ['./select-follow-up-actions.component.scss']
})
export class SelectFollowUpActionsComponent implements OnInit {

  @Input()
  workflowInstanceId: number;

  @Output()
  followUpTaskChange = new EventEmitter;

  followUpTasks: FollowUpTaskToAssociate[] = [];
  constructor(
    private workflowService: WorkflowService,
    private dialogService: DialogService,
    private tr: TranslateService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.workflowService.getAllFollowUpActions(this.workflowInstanceId).subscribe(
      res => {
        this.followUpTasks = res;
        this.followUpTaskChange.emit(res);
      },
      err => console.log(err)
    );
  }

  onCheckTask(event, id){
    this.followUpTasks.map(x => {
      if(x.followUpTaskId == id){
        if(event.checked){
          x.selected = true;
        }else{
          x.selected = false;
        }
      }
    })
    this.followUpTaskChange.emit(this.followUpTasks);
  }

  deleteTask(description: string){
    let msg = this.tr.instant("CASES.FOLLOW_UP_ACTIONS.DELETE_ACTION_WARNING");
    this.dialogService.openConfirmDialog(null, msg)
    .afterClosed()
    .subscribe((confirmed: boolean) => {
      if(confirmed){
        this.followUpTasks = this.followUpTasks.filter(x => x.description != description);
        this.followUpTaskChange.emit(this.followUpTasks);
      }
    });
  }

  onCreateAction(){
    const dialog = this.dialog.open(AddManualFollowUpActionDialog,
      {
        width: '500px'
      })
    dialog.afterClosed().subscribe(data => {
      if(data){
        const newTask: FollowUpTaskToAssociate = {
          description: data.description,
          selected: true
        }
        this.followUpTasks.push(newTask);
        this.followUpTaskChange.emit(this.followUpTasks);
      }
    });
  }
}

//Add Follow Up Action Manual
@Component({
  selector: 'add-manual-followup-action',
  template: `
            <div>
                <h2>{{"CASES.FOLLOW_UP_ACTIONS.NEW_FOLLOWUP_MANUAL_ACTION" | translate}}</h2>
                <div [formGroup]="form">
                  <mat-form-field appearance="outline" class="m-4" style="width: 100%;">
                      <mat-label>{{"CASES.FOLLOW_UP_ACTIONS.DESCRIPTION" | translate}}</mat-label>
                      <textarea matInput rows="6" formControlName="description" style="resize: none; overflow: scroll"></textarea>
                  </mat-form-field>
                </div>
                <div align="end">
                  <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="saveAction()">
                      {{"CASES.FOLLOW_UP_ACTIONS.ADD_ACTION" | translate}}
                  </button>
                </div>
            </div>
  `
})
export class AddManualFollowUpActionDialog {
  
  form: UntypedFormGroup;

  constructor(
   private fb: UntypedFormBuilder,
   public dialogRef: MatDialogRef<AddManualFollowUpActionDialog>,
  ){ }

  ngOnInit() {
    this.form = this.fb.group({
      description: ['', Validators.required]
    });
  }

  saveAction() {
    this.dialogRef.close(this.form.value);
  }
}
